import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

/**
 * Props interface for TracesStatusChips component
 */
interface TracesStatusChipsProps {
  /** The currently active status */
  activeStatus: string;
  /** Function to handle status chip click */
  handleStatusClick: (status: string) => void;
}

/**
 * TracesStatusChips component
 *
 * This component renders a set of status chips for trace filtering.
 * It allows users to select between 'All', 'Active', and 'Pending' statuses.
 *
 * @param {TracesStatusChipsProps} props - The component props
 * @returns {JSX.Element} A Stack of Chip components representing trace statuses
 */
const TracesStatusChips = ({
  activeStatus,
  handleStatusClick,
}: TracesStatusChipsProps) => {
  /** Array of available status options */
  const statusChip = ['All', 'Active', 'Pending'];

  return (
    <Stack
      spacing={1}
      direction={{ xs: 'column', sm: 'row', md: 'row', lg: 'row', xl: 'row' }}
      sx={{
        alignItems: 'center',
      }}
    >
      {statusChip.map((status, index) => (
        <Chip
          key={index}
          label={status}
          clickable
          onClick={() => handleStatusClick(status)}
          sx={{
            width: { xs: '100%', sm: '90px' },
            backgroundColor: status === activeStatus ? '#2B3493' : '#ffffff',
            color: status === activeStatus ? '#ffffff' : '#000000',
          }}
          variant='outlined'
        />
      ))}
    </Stack>
  );
};

export default TracesStatusChips;
